//App
import { LookupValueGridProps } from "../../../../types/lookupGroup";
import { useLookupValuesGridQuery } from "../LookupValue/hooks/useLookupValue";

//Common
import { Chip, DataGrid } from "../../../common/VFX-UI";
import { useState } from "react";
import { LookupValueState } from "../../../../types/lookupValue";

const LookupValueGrid = (props: LookupValueGridProps) => {
  const { lookupGroupId } = props;
  const [state, setState] = useState<LookupValueState>({
    lookupGroupId: lookupGroupId,
    currentPage: 1,
    sortBy: [{ field: "name", direction: 1 }],
    pageSize: 10,
  });

  const lookupValues = useLookupValuesGridQuery(state);
  const columns = [
    {
      dataField: "id",
      text: "ID",
      hidden: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
    },
    {
      dataField: "isActive",
      text: "Status",
      sort: false,
      formatter: (cell: boolean) => {
        return <Chip label={cell ? "Active" : "Inactive"} />;
      },
    },
  ];

  return (
    <DataGrid
      columns={columns}
      data={lookupValues.data?.result ?? []}
      keyField="id"
      totalSize={lookupValues?.data?.totalSize}
      remote={true}
      page={state?.currentPage}
      handlePageChange={async (newPage, pageSize ,sortField, sortOrder) => {
        if (newPage) {
          setState((prevState) => ({
            ...prevState,
            currentPage: newPage,
          }));
        }
        if (sortField && sortOrder) {
          setState((prevState) => ({
            ...prevState,
            sortBy: [
              { field: sortField, direction: sortOrder === "asc" ? 1 : -1 },
            ],
          }));
        }
      }}
    />
  );
};

export default LookupValueGrid;
